import { Input, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';

const validate = (policy, pass) => {
  const errors = {};
  if (policy.number) errors.number = !/[0-9]/.test(pass);
  if (policy.uppercase) errors.uppercase = !/[A-Z]/.test(pass);
  if (policy.symbol) errors.symbol = !/[-+=!$%^&*()_|~`{}[\]:/;<>?,.@#'"\s]/.test(pass.trim());
  errors.length = pass.length < (policy.length || 8);
  errors.trim = pass.length !== pass.trim().length;
  return errors;
};

const PolicyItem = ({ text, error }) => (
  <Text color={error ? 'red.500' : 'green.500'} textAlign="left" w="100%">
    <Text as="span" mr="2">&#10003;</Text>
    {text}
  </Text>
);

const PasswordPolicy = ({
  control, register, setValue, policy = {},
}) => {
  const pass = useWatch({ control, name: 'password' });
  const [state, setState] = useState();

  useEffect(() => {
    if (pass) {
      const newState = validate(policy, pass);
      setState(newState);
      setValue('pass', Object.values(newState).filter(Boolean).length === 0 ? 'true' : '', { shouldValidate: true });
    }
  }, [pass]);

  return (
    state && (
      <VStack fontSize="sm" gap="1" mb="6">
          {'number' in state && <PolicyItem error={state.number} text="Password must contain a number" />}
          {'uppercase' in state && <PolicyItem error={state.uppercase} text="Password must contain an upper case letter" />}
          {'symbol' in state && <PolicyItem error={state.symbol} text="Password must contain a special character" />}
          {'length' in state && <PolicyItem error={state.length} text={`Password must contain at least ${policy.length} characters`} />}
          {'trim' in state && <PolicyItem error={state.trim} text="Password must not contain a leading or trailing space" />}
        <Input size="sm" type="hidden" {...register('pass', { required: true })} />
      </VStack>
    )
  );
};

export default PasswordPolicy;
